// Business facts used across the site. Keep these in one place so commercial
// terms stay consistent between pages.

export const business = {
  name: 'GoldCrusade',
  tagline: 'AI assistants. Practical implementation. Ongoing consulting.',
  email: 'info@goldcrusade.com',
  phone: '+1 (714) 595-9102',
  discoveryMinutes: 30,
  /**
   * Optional scheduling page (e.g. Cal.com or Calendly). When set, step 2 of
   * /start embeds it and the scheduler should redirect to
   * `/start/confirmed?status=booked`. When unset, /start collects preferred
   * availability as a request instead of a confirmed booking.
   */
  schedulingUrl: (import.meta.env.VITE_SCHEDULING_URL as string | undefined) || '',
};

/**
 * Founder details for /about. Sections that depend on these only render once
 * they are filled in with real information — never ship placeholder people.
 */
export const founder: {
  name: string;
  role: string;
  photo: string;
  bio: string[];
  experience: string[];
} | null = null;

/**
 * Verified implementation examples for /about. Label each by kind so earlier
 * website or automation work is never presented as an AI pilot result.
 */
export const relevantWork: {
  title: string;
  kind: 'AI pilot' | 'Automation' | 'Website';
  summary: string;
}[] = [];
